import { Fragment } from 'react'
import { observer } from 'mobx-react-lite'
import { FreeMode } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import styled from 'styled-components'

import { FilterList, PARAM_FILTER } from '../../constants'
import type { CATEGORY_LIST, PARAM_SORT_TYPE } from '../../constants'

import { Chip } from '../chip'
import { SelectSort } from '../select'

interface Props {
  filterData?: {
    filterList: FilterList
    filterType: string
    setFilterType: (type: PARAM_FILTER) => void
  }
  sortData?: {
    sortList: { type: string; title: string }[]
    sortType: PARAM_SORT_TYPE
    setSortType: (type: PARAM_SORT_TYPE) => void
  }
  slideFilterData?: {
    filterList: FilterList
    filterType: string | undefined
    setFilterType: (type: PARAM_FILTER) => void
  }
  categoryData?: {
    categoryList: CATEGORY_LIST
    categoryId: number | undefined
    setCategoryId: (id: number | undefined) => void
  }
}

export const ParamOption = observer(({ filterData, sortData, slideFilterData, categoryData }: Props) => {
  return (
    <>
      {slideFilterData && (
        <StyledSwiper autoHeight={true} freeMode={true} slidesPerView="auto" spaceBetween={8} modules={[FreeMode]}>
          {slideFilterData.filterList.map((d, i) => {
            const isActive = slideFilterData.filterType === d.type
            return (
              <SlideItem key={i}>
                <Chip
                  $color={isActive ? 'black' : 'white'}
                  onClick={() => slideFilterData.setFilterType(d.type as PARAM_FILTER)}
                >
                  {d.title ?? '-'}
                </Chip>
              </SlideItem>
            )
          })}
        </StyledSwiper>
      )}
      {categoryData && (
        <StyledSwiper autoHeight={true} freeMode={true} slidesPerView="auto" spaceBetween={8} modules={[FreeMode]}>
          {categoryData.categoryList.map(({ id, title, name }, i) => {
            if (typeof id === 'undefined') return <Fragment key={`f${i}`} />
            const isActive = (id === 1 && categoryData.categoryId === undefined) || categoryData.categoryId === id
            return (
              <SlideItem key={i}>
                <Chip
                  $color={isActive ? 'black' : 'white'}
                  onClick={() => categoryData.setCategoryId(id === 1 ? undefined : id)}
                >
                  {name === '미지정' ? '전체' : (title ?? name ?? '-')}
                </Chip>
              </SlideItem>
            )
          })}
        </StyledSwiper>
      )}
      {(filterData || sortData) && (
        <OptionContainer>
          {filterData && (
            <FilterContainer>
              {filterData.filterList.map((d, i) => (
                <span
                  key={i}
                  className={`${filterData.filterType === d.type ? 'active' : ''}`}
                  onClick={() => filterData.setFilterType(d.type as PARAM_FILTER)}
                  style={{ paddingLeft: '0px' }}
                >
                  {d.title}
                </span>
              ))}
            </FilterContainer>
          )}
          {sortData && (
            <SelectWrap>
              <SelectSort
                sortType={sortData.sortType}
                setSortType={sortData.setSortType}
                sortList={sortData.sortList}
              />
            </SelectWrap>
          )}
        </OptionContainer>
      )}
    </>
  )
})

const OptionContainer = styled.section`
  display: flex;
  align-items: center;
  padding: 0 20px;
`

const FilterContainer = styled.div`
  width: 100%;
  color: #92949c;
  font-size: 13px;
  span {
    padding: 0 10px 0 0;
    :hover {
      cursor: pointer;
    }
  }
  span.active {
    font-weight: bold;
    @media (prefers-color-scheme: light) {
      color: black;
    }
    @media (prefers-color-scheme: dark) {
      color: white;
    }
  }
`

const StyledSwiper = styled(Swiper)`
  margin: 0;
  padding: 0 16px;
`

const SlideItem = styled(SwiperSlide)`
  width: auto !important;
  height: 35px !important;
  line-height: 100%;
`

const SelectWrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: end;
`
